import { render, staticRenderFns } from "./learning-expectation-rating.vue?vue&type=template&id=0670ea9a&scoped=true&"
import script from "./learning-expectation-rating.vue?vue&type=script&lang=js&"
export * from "./learning-expectation-rating.vue?vue&type=script&lang=js&"
import style0 from "./learning-expectation-rating.vue?vue&type=style&index=0&id=0670ea9a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0670ea9a",
  null
  
)

export default component.exports